import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { getUser } from "../../../services/auth";
import "./index.css";

const MobileNavBar = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (userInfo === null) {
      return false;
    } else {
      setUser(userInfo);
    }
    // eslint-disable-next-line
  }, []);

  const userInfo = getUser();
  return (
    <div className="sidebar-sm">
      <ul>
        {user !== null && (
          <>
            <li>
              <NavLink to="/dashboard" exact={true} activeClassName="active">
                <div className="profile-sidebar">Dashboard</div>
              </NavLink>
            </li>
            <li>
              <NavLink to="/profile" exact={true} activeClassName="active">
                <div className="sidebar-nav">Wallet</div>
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/bookinghistory"
                exact={true}
                activeClassName="active"
              >
                <div className="sidebar-nav">Booking History</div>
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                to="/bills-payment"
                exact={true}
                activeClassName="active"
              >
                <div className="sidebar-nav">Bills Payment</div>
              </NavLink>
            </li> */}
          </>
        )}

        <li>
          <NavLink to="/support" exact={true} activeClassName="active">
            <div className="sidebar-nav">Help &amp; Support</div>
          </NavLink>
        </li>

        <li>
          <NavLink to="/setting" exact={true} activeClassName="active">
            <div className="sidebar-nav">Setting</div>
          </NavLink>
        </li>

        <li>
          <NavLink to="/referral" exact={true} activeClassName="active">
            <div className="sidebar-nav">Referral</div>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default MobileNavBar;
